import gql from "graphql-tag";

import { fragmentAddress } from "./address";

export const fragmentOrderEvent = gql`
  fragment OrderEventFragment on OrderEvent {
    id
    amount
    date
    email
    emailType
    invoiceNumber
    message
    quantity
    referenceId3pl
    type
    user {
      id
      email
    }
    changeRemittanceManualAdjustmentStatus {
      adjustmentReason
      oldTotalAmount
      adjustedAmount
      adjustedTotalAmount
      oldStatus
      newStatus
    }
    createRemittanceManualAdjustment {
      adjustmentReason
      oldTotalAmount
      adjustedAmount
      adjustedTotalAmount
      oldStatus
      newStatus
    }
  }
`;

// export const fragmentOrderLine = gql`
//   fragment OrderLineFragment on OrderLine {
//     id
//     isShippingRequired
//     variant {
//       id
//       product {
//         id
//         isAvailableForPurchase
//         isPublished
//       }
//       quantityAvailable
//     }
//     productName
//     productSku
//     quantity
//     quantityFulfilled
//     unitPrice {
//       gross {
//         amount
//         currency
//       }
//       net {
//         amount
//         currency
//       }
//     }
//     thumbnail {
//       url
//     }
//   }
// `;

export const fragmentOrderLine = gql`
  fragment OrderLineFragment on OrderLine {
    id
    isShippingRequired
    variant {
      id
      quantityAvailable
    }
    productName
    productSku
    quantity
    quantityFulfilled
    unitPrice {
      gross {
        amount
        currency
      }
      net {
        amount
        currency
      }
    }
    thumbnail {
      url
    }
  }
`;

export const fulfillmentFragment = gql`
  ${fragmentOrderLine}
  fragment FulfillmentFragment on Fulfillment {
    id
    lines {
      id
      quantity
      orderLine {
        ...OrderLineFragment
      }
    }
    fulfillmentOrder
    status
    trackingNumber
    warehouse {
      id
      name
    }
  }
`;

export const invoiceFragment = gql`
  fragment InvoiceFragment on Invoice {
    id
    number
    createdAt
    url
    status
  }
`;

export const fragmentOrderDetails = gql`
  ${fragmentAddress}
  ${fragmentOrderEvent}
  ${invoiceFragment}
  fragment OrderDetailsFragment on Order {
    id
    dispatchNo
    awbNo
    billingAddress {
      ...AddressFragment
    }
    smopStatus
    canFinalize
    created
    customerNote
    events {
      ...OrderEventFragment
    }
    number
    payments {
      id
      paymentMethodType
      chargeStatus
      created
      channelCode
    }
    paymentStatus
    shippingAddress {
      ...AddressFragment
      latitude
      longitude
      unitDetails
      streetBrgy
      landmark
      provinceName
      provinceCode
      portCode
    }
    shippingSchedule
    shippingMethod {
      deliveryType
      id
    }
    shippingMethodName
    shippingPrice {
      gross {
        amount
        currency
      }
    }
    weight {
      value
      unit
    }
    status
    subtotal {
      gross {
        amount
        currency
      }
    }
    mall {
      id
      name
      address {
        id
        streetAddress1
        streetAddress2
        cityArea
        city
        countryArea
        postalCode
      }
      warehouses(first: 100) {
        edges {
          node {
            id
            name
            address {
              id
              companyName
              streetAddress1
              streetAddress2
              city
              cityArea
              postalCode
              country {
                country
              }
              countryArea
              phone
            }
            homeLocations {
              id
              name
            }
          }
        }
      }
    }
    orderCode
    subOrders {
      id
      smac
      orderCode
      smopStatus
      parcelNo
      validatedAt
      validatedBy {
        id
        firstName
        lastName
        email
      }
      validatedForPackingBy {
        id
        email
        firstName
      }
      prepTimeUpper
      prepTimeLower
      tenant {
        id
        legalName
        storeName
        location
        brand {
          id
          name
          logo {
            url
            alt
          }
        }
      }
      lines {
        id
        productName
        variantName
        quantity
        unitPrice {
          gross {
            amount
          }
        }
        storeOrder {
          id
        }
        totalPrice {
          gross {
            amount
          }
        }
        status
        notes
        variant {
          id
          name
          sku
        }
      }
      discountAmount
      totalAmount
      subtotal
    }
    total {
      gross {
        amount
        currency
      }
      tax {
        amount
        currency
      }
    }
    actions
    totalAuthorized {
      amount
      currency
    }
    totalCaptured {
      amount
      currency
    }
    user {
      id
      email
      firstName
      lastName
      contactNo
      smac
      defaultShippingAddress {
        id
        streetAddress1
        streetAddress2
        city
        cityArea
        postalCode
        country {
          country
        }
        countryArea
        phone
      }
    }
    userEmail
    availableShippingMethods {
      id
      name
      price {
        amount
        currency
      }
    }
    discountName
    discount {
      amount
      currency
    }
    invoices {
      ...InvoiceFragment
    }
    rider {
      id
      email
      firstName
      lastName
      contactNo
    }
    isRider3pl
    thirdPartyRider {
      id
      firstName
      lastName
      contactNo
      trackingUrl
      deliveryCourier {
        senderContactNo
        senderFirstName
        senderLastName
        shippingCompany
        referenceNo
        notes
        status
        homeLocation {
          id
          name
        }
        riderPickUpLocation {
          id
          latitude
          longitude
          name
          remarks
        }
        pickUpImageUrl {
          url
          alt
        }
        dropOffImageUrl {
          url
          alt
        }
        returnImageUrl {
          url
          alt
        }
      }
    }
    courier
    thirdPartyAwbCode
    cancelReason
    isMultiTenant
    voucher {
      id
      name
      type
      code
      discountValueType
      discountValue
    }
    specialNotes
    verticalType
    images {
      id
      sortOrder
      alt
      url
    }
    shippedAt
    completedAt
    dwellTime
    totalTime
    onTime
    distanceFromMall
    lateDeliveryReason
    lateDispatchReason
  }
`;

export const exportFileFragment = gql`
  fragment ExportFileFragment on ExportFile {
    id
    status
    url
  }
`;
